import RatingContainer from './rating_container.js'

export default {
  RatingContainer,
}
